import React from 'react'
import bottomline from "../asset/bottomline.png"
import { Helmet } from 'react-helmet'
import blog3 from "../asset/blog3.png"

function Blog3() {
    return (
        <article className="min-h-screen">
            <Helmet>
                <title>Best Places to Visit in Mukteshwar, Uttarakhand</title>
                <meta
                    name="description"
                    content="Here are some beautiful places to visit if you are coming to Mukteshwar. These locations are settled amid superb location which can make your trip unforgettable"
                />
            </Helmet>

            {/* Hero Section */}
            <div className="relative">
                <div className="absolute inset-0 bg-black/40" />
                <img
                    className="h-[50vh] w-full object-cover object-top"
                    src={blog3}
                    alt="Places to Visit in Mukteshwar"
                />
                <div className="absolute inset-0 flex items-center justify-center">

                </div>
            </div>

            <div className='mx-3 flex flex-col mt-[60px] justify-center items-center'>
                <h1 className='text-3xl font-bold mb-2 text-center poppins text-green-700 uppercase tracking-wider yeseva'>
                    Best Places to Visit in Mukteshwar, Uttarakhand
                </h1>
                <img className="ml-[-10px] mb-3 md:block hidden" src={bottomline} alt="" />
                <img className="ml-[-10px] mb-3 md:hidden block w-[300px]" src={bottomline} alt="" />
            </div>

            <div className=' my-4 conatiner overflow-hidden w-[80%] mx-auto'>
                <img className='object-cover hover:scale-105 transition-all duration-500' src={blog3}
                    alt="Places to Visit in Mukteshwar" />
            </div>

            {/* Main Content */}
            <div className="mx-auto max-w-6xl px-2 text-justify">
                {/* Introduction */}
                <div className="rounded-2xl p-6 backdrop-blur-sm">
                    <p
                        className="mb-6 last:mb-0 flex flex-col gap-3 text-lg leading-relaxed text-gray-800 md:text-xl"
                    >
                        <p> Welcome to <b>Mukteshwar</b>, a hidden gem in the Kumaon hills of Uttarakhand, where time slows down and nature takes center stage. Whether you’re visiting for a quick getaway or dreaming of a permanent mountain retreat, this quaint hill station is the kind of place that leaves you wanting more.
                        </p>

                        <p>And the best part? Our<b> Indus Valley </b> township brings you a chance to not just visit but also live in this paradise—inside a <b>gated community</b> offering <b> independent villas</b>, modern amenities, and stunning Himalayan views right from your balcony.</p>

                        <p>A great project is not enough. We need interesting nearby places to visit. Let’s explore some of the must-visit places that are not only picture-perfect but also, these places are beautifully amazing where you can spend time with your family and create so many memories.</p>

                    </p>
                </div>

                {/* Highlights Section */}
                <section className="">
                    <h2 className="mt-8 text-center text-3xl font-bold text-red-800 md:text-3xl">
                        Mukteshwar Mahadev Temple – Where Peace Meets the Peaks
                    </h2>
                    <div className="rounded-2xl p-6 backdrop-blur-sm">
                        <p className="ml-6 text-lg text-gray-800">
                            This place is Also known as Mukteshwar Dham Temple. A <b>25-minute drive</b> from Indus Valley takes you to the iconic Mukteshwar Mahadev Temple, an ancient shrine dedicated to Lord Shiva. Sitting at 7585 feet above sea level, this spot offers 360-degree views of the Himalayan range—ideal for your sunrise yoga or sunset reflection. The temple is believed to be over 350 years old and carries with it an air of serenity that’s hard to find elsewhere.
                        </p>
                    </div>
                </section>
                <section className="">
                    <h3 className="mt-8 text-center text-3xl font-bold text-red-800 md:text-3xl">
                        Chauli Ki Jali – Adventure with a View
                    </h3>
                    <div className="rounded-2xl p-6 backdrop-blur-sm">
                        <p className="ml-6 text-lg text-gray-800">
                            Right next to the temple lies Chauli Ki Jali; it’s a 15-minute track from the temple to a rocky cliff with mythological significance and a hotspot for adventure lovers. The site offers breathtaking views of the valley and is a great place for photography, rock climbing, and rappelling. This place also has many street food vendors where you can snack and enjoy your time with your loved ones.
                        </p>
                    </div>
                </section>
                <section className="">
                    <h4 className="mt-8 text-center text-3xl font-bold text-red-800 md:text-3xl">
                        Bhalu Gaad Waterfall – A Hidden Paradise

                    </h4>
                    <div className="rounded-2xl p-6 backdrop-blur-sm">
                        <p className="ml-6 text-lg text-gray-800">
                            <b>A 30-minute drive </b> from Indus Valley. This place got a short trek through dense forest trails takes you to the magical Bhalu Gaad Waterfall; it’s a 20-minute track from each side, which leads to one of Mukteshwar’s best-kept secrets. The peaceful ambiance, gushing falls, and bird calls make it ideal for nature walks and picnics.  The waterfall plunges from a height of over 30 feet, creating a crystal-clear pool below that's perfect for a quick dip or simply dipping your toes while soaking in the serenity. And if you are you’re craving a warm cup of chai, a plate of Maggi, or a plate of hot pakoras, you’ll have tasty company to go with the views.
                        </p>
                    </div>
                </section>
                <section className="">
                    <h5 className="mt-8 text-center text-3xl font-bold text-red-800 md:text-3xl">
                        Bhimtal Lake - A peaceful lakeside escape

                    </h5>
                    <div className="rounded-2xl p-6 backdrop-blur-sm">
                        <p className="ml-6 text-lg text-gray-800">
                            Just a <b> 1-hour drive </b> from Indus Valley, Bhimtal offers it all—from a serene lake nestled among the mountains to a lively Mall Road where you can shop, stroll, and savor local street food. You can enjoy boating, explore quaint cafés nearby, or simply sit by the water watching the reflections of the hills dance on the surface. For those who appreciate a mix of nature and leisure, Bhimtal makes for a perfect day trip from the Indus Valley.
                        </p>
                    </div>
                </section>
                <section className="">
                    <h6 className="mt-8 text-center text-3xl font-bold text-red-800 md:text-3xl">
                        Starscapes Observatory & Experience Centre –  A Celestial Experience in Mukteshwar

                    </h6>
                    <div className="rounded-2xl p-6 backdrop-blur-sm">
                        <p className="ml-6 text-lg text-gray-800">
                            Nestled amidst the serene Kumaon hills, the Starscapes Observatory & Experience Centre in Mukteshwar offers an unparalleled stargazing experience. Established in September 2022, this observatory provides visitors with the opportunity to explore the night sky like never before.
                        </p>
                    </div>
                </section>
                <section className="">
                    <p className="mt-8 text-center text-3xl font-bold md:text-xl">
                        Indus Valley is the Perfect Home in Mukteshwar with all the amazing places nearby.
                    </p>
                </section>
            </div>
        </article>
    )
}

export default Blog3